//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WishlistsDetailModal from './DetailModal.vue';
import PlaceholderImage from '~/static/image-placeholder.svg';

export default {
  components: {
    WishlistsDetailModal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },

    dealId: {
      type: Number,
      required: true,
    },
  },

  async fetch() {
    await this.$store.dispatch('wishlists/getWishlists');

    if (this.requestErrorMessage && this.$toastr) {
      this.$toastr.e(this.requestErrorMessage);
      return;
    }

    this.wishlists = this.$store.getters['wishlists/wishlists'];
    this.selectedWishlist = this.wishlist;
    this.selectedWishlistId = this.selectedWishlist.id;
    this.selectedWishlistIdCopy = this.selectedWishlistId;
  },

  data() {
    return {
      wishlists: [],
      selectedWishlist: null,
      selectedWishlistId: 0,

      // Stores original wishlist id, set again user closes the modal
      // and didn't select a new wishlist
      selectedWishlistIdCopy: 0,

      // Stores the relashionship id between deals and wishlists,
      // this is used to remove a deal from a wishlist.
      wishlistDealId: 0,

      // For internal use, this should be sync with the showModal property
      showModalInternal: false,
      PlaceholderImage,

      // Create modal
      showCreatemodal: false,
    };
  },

  computed: {
    // Get the wishlist object that the deal belongs to, and also assigns wishlistDealId
    wishlist() {
      return this.wishlists.find(
        (x) => x.deals.find((y) => {
          if (y.id === this.dealId) {
            this.wishlistDealId = y.wishlist_deal_id;
            return true;
          }

          return null;
        }),
      ) || {};
    },

    // Deal is already on a wishlist
    dealIsInWishlist() {
      return !!this.selectedWishlistIdCopy;
    },

    isRemovingFromWishlist() {
      return this.dealIsInWishlist && this.selectedWishlistId === 0;
    },

    requestErrorMessage() {
      return this.$store.getters['wishlists/errorMessage'];
    },

    isProcessing() {
      return this.$store.getters['wishlists/isProcessing'];
    },
  },

  watch: {
    showModal(newValue) {
      // Refresh wishlists when opening the modal
      // Once the cache issue is fixed I think we can remove this
      if (newValue) {
        this.$fetch();
      }

      // Sync internal variable
      this.showModalInternal = newValue;
    },

    // Create wishlist modal is closed open this
    showCreatemodal(newValue) {
      if (!newValue) {
        this.showModalInternal = true;
      }
    },
  },

  methods: {
    close() {
      this.showModalInternal = false;
      this.selectedWishlistId = this.selectedWishlistIdCopy;

      this.$emit('update:showModal', this.showModalInternal);
    },

    done() {
      // No new wishlist selected then close modal
      if (
        (!this.selectedWishlistIdCopy && !this.selectedWishlistId)
          || this.selectedWishlistIdCopy === this.selectedWishlistId
      ) {
        this.close();
        return;
      }

      if (this.isRemovingFromWishlist) {
        this.removeFromList();
      } else {
        this.saveList();
      }
    },

    async removeFromList() {
      if (this.isProcessing) {
        return;
      }

      await this.$store.dispatch('wishlists/removeFromList', { wishlistDealId: this.wishlistDealId });

      if (this.requestErrorMessage) {
        this.$toastr.e(this.requestErrorMessage);
        return;
      }

      await this.$store.dispatch('wishlists/setWishlist', null);

      this.$toastr.s(`Removed from <strong>${this.wishlist.name}</strong> wishlist!`);

      const wishlistsCount = this.$store.getters['wishlists/wishlistsCount'];

      // If deal is in a wishlist reduce counter
      if (this.isRemovingFromWishlist) {
        await this.$store.dispatch('wishlists/setWishlistCount', { value: wishlistsCount - 1 });
      }

      this.showModalInternal = false;
      this.$emit('update:showModal', this.showModalInternal);

      // Update modal
      this.$fetch();
    },

    selectList(wishlist) {
      if (this.selectedWishlistId && this.selectedWishlistId === wishlist.id) {
        this.selectedWishlistId = 0;
        return;
      }

      this.selectedWishlist = wishlist;
      this.selectedWishlistId = this.selectedWishlist.id;
    },

    async saveList() {
      if (this.isProcessing) {
        return;
      }

      const wishlistsCount = this.$store.getters['wishlists/wishlistsCount'];

      const requestData = {
        // Used to remove from previous deal
        removeFromList: this.dealIsInWishlist,
        wishlistDealId: this.wishlistDealId,

        // Used to add add to new wishlist
        user: this.$store.state.session.user.id,
        wishlist: this.selectedWishlistId,
        deal: this.dealId,
      };

      await this.$store.dispatch('wishlists/saveToList', requestData);

      if (this.requestErrorMessage) {
        this.$toastr.e(this.requestErrorMessage);
        return;
      }

      // If deal is added to a new list then update state
      if (!this.dealIsInWishlist) {
        await this.$store.dispatch('wishlists/setWishlistCount', { value: wishlistsCount + 1 });
      }

      await this.$store.dispatch('wishlists/setWishlist', this.selectedWishlist);

      this.$toastr.s(`Saved to <strong>${this.selectedWishlist.name}</strong> wishlist!`);

      this.showModalInternal = false;
      this.$emit('update:showModal', this.showModalInternal);

      // Update modal
      this.$fetch();
    },

    openCreateModal() {
      this.showModalInternal = false;
      this.showCreatemodal = true;
    },

    getNumberOfItemsLabel(item) {
      const { length } = item.deals;
      const label = length === 1 ? ' item' : ' items';

      return length + label;
    },
  },
};
